/** Metadata anchors are half-open UTF-16 ranges and may overlap. */
export function getHasOneWithoutKindInSelection(
  metadata: { anchors: { utf16Start: number; utf16Size: number }[] }[],
  position: { start: number; size: number },
) {
  const end = position.start + position.size;
  let coveredUntil = position.start;
  const anchors = metadata
    .flatMap((item) => item.anchors)
    .sort((a, b) => a.utf16Start - b.utf16Start);
  for (const anchor of anchors) {
    if (coveredUntil >= end) return false;
    if (anchor.utf16Start > coveredUntil) return true;
    coveredUntil = Math.max(coveredUntil, anchor.utf16Start + anchor.utf16Size);
  }
  return coveredUntil < end;
}
